"use client";

import { getRelatedContents } from "actions/content";
import useSWR from "swr";
import Card from "./Card";

interface IProps {
  typeId: number;
  languageId: string;
  take: number;
  tagId?: string;
}

function RelatedPost(props: IProps) {
  const relatedPosts = useSWR(
    "RelatedPost" + props.typeId + props.languageId + props.take + props.tagId,
    () =>
      getRelatedContents(
        props.typeId,
        props.languageId,
        props.take,
        props.tagId
      )
  );

  return (
    <div className="grid md:grid-cols-3 grid-cols-1 gap-[32px]">
      {relatedPosts.isLoading ? (
        <></>
      ) : (
        relatedPosts.data?.map((item) => (
          <Card
            type={item.type}
            id={item.id}
            contentByLangs={item.contentByLangs}
            text="black"
          />
        ))
      )}
    </div>
  );
}

export default RelatedPost;
